import {
  ApolloCache,
  DefaultContext,
  DocumentNode,
  MutationHookOptions,
  MutationTuple,
  OperationVariables,
  TypedDocumentNode,
  useMutation as useApolloMutation,
} from '@apollo/client';
import { useToast } from '../providers/ToastProvider';
import { ToastType } from '../ui/components/Toast';

export default function useMutation<
  TData = any,
  TVariables = OperationVariables,
  TContext = DefaultContext,
  TCache extends ApolloCache<any> = ApolloCache<any>,
>(
  mutation: DocumentNode | TypedDocumentNode<TData, TVariables>,
  options?: MutationHookOptions<TData, TVariables, TContext>,
): MutationTuple<TData, TVariables, TContext, TCache> {
  const { showToast } = useToast();

  return useApolloMutation<TData, TVariables, TContext, TCache>(mutation, {
    ...options,
    onError: error => {
      console.error(error);
      if (options?.onError) return options.onError(error);

      const message = error.message;
      if (message.length > 75) {
        showToast({ type: ToastType.error, title: 'An error has occurred!', content: message });
      } else {
        showToast({ type: ToastType.error, title: message });
      }
    },
  });
}
